import { useState } from "react";
import { Check } from "lucide-react";
import Reveal from "./Reveal";
import { tc, tb, tbr } from "../lib/themeStyles";

const TABS = [
  {
    id: "sheet",
    label: "Sheet Metal & Blanking",
    items: [
      "CNC Fiber Laser Cutting — up to 25mm",
      "High-tonnage CNC Press Brake Bending",
      "CNC Turret Punching",
      "Geometric Stamping & Blanking",
    ],
    aside: "Repeatable cuts across mild steel, stainless, and aluminum stocks.",
  },
  {
    id: "machining",
    label: "Precision Machining",
    items: [
      "Multi-axis VMC (Vertical Machining Centers)",
      "CNC Turning Centers",
      "Heavy Boring & Milling",
      "Tolerance control: ±0.005mm",
    ],
    aside: "CMM-verified critical features, SPC charts on every batch.",
  },
  {
    id: "fab",
    label: "Fabrication & Assembly",
    items: [
      "Certified MIG & TIG Structural Welding",
      "5-Ton & 10-Ton Overhead Cranes",
      "Custom In-House Jigs & Fixtures",
      "Sub-assembly & final assembly capability",
    ],
    aside:
      "Skid-mounted assemblies, weldments up to 8 tonnes, turnkey integration before crating.",
  },
];

export default function CapabilitiesTabs() {
  const [active, setActive] = useState("sheet");
  const tab = TABS.find((t) => t.id === active);

  return (
    <section className="section-shell">
      <div className="section-inner">
        <Reveal>
          <div className="label-cap mb-4" style={tc.accent}>
            02 — Process Detail
          </div>
          <h2 className="section-title max-w-[720px] mb-12">
            Every cut, bend, and weld is traceable.
          </h2>
        </Reveal>

        <Reveal delay={80}>
          <div className="flex flex-wrap gap-2 md:gap-3">
            {TABS.map((t) => (
              <button
                key={t.id}
                type="button"
                onClick={() => setActive(t.id)}
                className={`tab-pill ${active === t.id ? "tab-pill-active" : "tab-pill-inactive"}`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120} className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 glass rounded-2xl p-8 md:p-10">
            <ul className="space-y-4">
              {tab.items.map((item) => (
                <li key={item} className="flex items-start gap-4 group">
                  <span
                    className="mt-1 w-7 h-7 shrink-0 rounded-full border flex items-center justify-center transition-colors"
                    style={{ ...tbr.default, ...tc.accent }}
                  >
                    <Check size={14} style={tc.accent} />
                  </span>
                  <span className="text-[16px] md:text-[18px] leading-[1.6]" style={tc.primary}>
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div
            className="rounded-2xl border p-8 flex flex-col justify-between min-h-[280px]"
            style={{ ...tb.surface, ...tbr.default }}
          >
            <div>
              <div className="label-cap" style={tc.muted}>
                Note
              </div>
              <p className="text-[16px] leading-[1.7] mt-4" style={tc.primary}>
                {tab.aside}
              </p>
            </div>
            <div className="mt-8 pt-6 border-t" style={tbr.default}>
              <a href="#rfq" className="link-reveal text-[14px] font-medium">
                Request a quote →
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
